<template>
  <div>
    <div id="basic-non-sticky-notification" class="toastify-content hidden flex flex-col sm:flex-row">
      <div class="flex items-center justify-around" v-if="pagedata.message">
        <CheckCircleIcon class="w-6 h-6 text-theme-9 mx-auto" />
        <div class="font-medium text-black">{{ pagedata.message }}</div>
      </div>
    </div>
    <h2 class="intro-y text-lg font-medium mt-10">Rate Requests</h2>
      <!-- BEGIN: Data List -->
      <div v-if="pagedata.loading == true" class="text-center text-md mt-5">Loading...</div>
      <div v-else>
        <div v-if="rates.length <= 0" class="text-center text-md mt-5">Requests Not Found</div>
        <div v-else class="intro-y col-span-12 overflow-auto lg:overflow-visible mt-5">
          <table class="table-report -mt-2">
            <thead>
              <tr>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">No</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">User</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Packet</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">T_Id</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Process</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Labour</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Weight</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Shape</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Color</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Purity</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Cut</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Polish</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Symm</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Fluer</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Tension</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Stone</th>
                <th class="px-1 md:px-2 xl:px-2 py-3 whitespace-nowrap">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(rate, index) in rates"
                :key="index"
                class="intro-x"
              >
                <td  class="text-center">{{ index + 1 }}</td>
                <td>
                  <div class="font-medium whitespace-nowrap">{{
                    rate.manager
                  }}</div>
                </td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.packet }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.t_id }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.process }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center"><span v-if="rate.labour == 1">Issue Weight</span><span v-if="rate.labour == 2">Fixed Piece</span><span v-if="rate.labour == 3">Weight + Weight</span><span v-if="rate.labour == 4">Piece + Piece</span><span v-if="rate.labour == 5">Weight Loss</span></td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.weight }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.shape }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.color }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.purity }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.cut }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.polish }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.symmetry }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.fluerocent }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.tension }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 font-medium text-center">{{ rate.stone }}</td>
                <td class="px-1 md:px-2 xl:px-2 py-3 table-report__action">
                  <div class="flex justify-center items-center">
                    <a class="btn btn-success mr-1 p-1" href="javascript:;" @click="acceptChange(rate.id)">
                      <CheckSquareIcon class="w-5 h-5" />
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- END: Data List -->
  </div>
</template>
<script>
/* eslint-disable */
import { BASE_URL } from '@/constants/config'
import axios from 'axios'
import Toastify from 'toastify-js'
import cash from 'cash-dom'
import { defineComponent, onMounted, reactive, ref } from 'vue'

export default defineComponent({
  setup() {
    const rates = ref([])
    const pagedata = reactive({
      message: '',
      accept_id: '',
      loading: true
    })
    onMounted(() => {
      getRates()
    })
    function getRates() {
      pagedata.loading = true
      axios({
        url: '/packet/manager-rate-request',
        method: 'get',
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { 'Accept':'application/json' } }
      }).then((res) => {
        pagedata.loading = false
        rates.value = res.data.rates
      }).catch(() => {
        pagedata.loading = false
      })
    }
    function acceptChange(id) {
      axios({
        url: `/packet/manager-accept-rate-request/${id}`,
        method: 'get',
        baseURL: BASE_URL,
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        config: { headers: { 'Accept':'application/json' } }
      }).then((res) => {
        pagedata.message = res.data.success
        pagedata.loading = false
        getRates()
        setTimeout(() => {
          basicNonStickyNotification()
        }, 100);
      }).catch(() => {
        pagedata.loading = false
      })
    }
    const basicNonStickyNotification = () => {
      Toastify({
        node: cash('#basic-non-sticky-notification')
          .clone()
          .removeClass('hidden')[0],
        duration: 5000,
        newWindow: true,
        close: true,
        gravity: 'top',
        position: 'right',
        stopOnFocus: true
      }).showToast()
    }
    return {
      pagedata,
      rates,
      acceptChange,
      basicNonStickyNotification
    }
  }
})
</script>
